import { render, staticRenderFns } from "./CmgCreateAccountPage.vue?vue&type=template&id=138fa8e8&scoped=true&lang=pug"
import script from "./cmg-create-account-page.ts?vue&type=script&lang=ts&external"
export * from "./cmg-create-account-page.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgCreateAccountPage.vue?vue&type=style&index=0&id=138fa8e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138fa8e8",
  null
  
)

export default component.exports